import { useNavigate } from "react-router-dom";


const Footer = () => {
    const navigate = useNavigate();

    return (
        <div className="footer">
            <p onClick={() => navigate('/terms')}>terms</p>
            <p onClick={() => navigate('/contact')}>contact</p>
        </div>
    )
}

export default Footer;